import { MruCache } from 'owa-mru-cache';
var cacheSize = 50;
var conversationCache = new MruCache(cacheSize);
export default conversationCache;
//# sourceMappingURL=conversationCache.js.map